// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

export default {
  Card: {
    select: '선택하기',
    titleLinkTooltip: '페이지로 이동',
    collapseCardTooltip: '카드 접기',
    expandCardTooltip: '카드 펼치기'
  },
  CardList: {
    loadMore: '더 불러오기',
    notFound: '아이템 찾을 수 없음.',
    toolbarSelect: '선택하기',
    viewCards: '카드',
    viewTiles: '타일',
    viewList: '목록',
    toolbarView: '보기'
  },
  ClosingConfirmation: {
    confirm: '나가기',
    cancel: '돌아가기',
    content: '정말로 이 창을 닫고 나가시겠습니까? 데이터 변경 사항이 저장되지 않습니다.'
  },
  Cuttable: {
    showMore: '더 보기',
    showLess: '간단히'
  },
  Dialog: {
    cancelButton: '취소'
  },
  DrawerProgress: {
    cancelButton: '취소'
  },
  Dropdown: {
    close: '닫기'
  },
  Form: {
    submitButton: '저장하기',
    applyButton: '적용하기',
    cancelButton: '취소'
  },
  FormField: {
    clear: '비우기',
    remove: '제거하기',
    addMore: '하나 더 추가'
  },
  FormFieldPassword: {
    improvePassword: '비밀번호 개선하기:',
    passwordTooShort: '비밀번호를 더 길게 만드세요.',
    lettersLowerCase: '소문자를 한 개 이상 사용하세요.',
    lettersUpperCase: '대문자를 한 개 이상 사용하세요.',
    numbers1: '숫자를 한 개 이상 사용하세요.',
    numbers3: '숫자를 세 개 이상 사용하세요.',
    specialChar1: '특수 기호를 한 개 이상 사용하세요(예: !, @, #, $, %, ^, &, *, ?, _, ~).',
    specialChar2: '특수 기호를 추 개 이상 사용하세요(예: !, @, #, $, %, ^, &, *, ?, _, ~).',
    comboUpperAndLower: '대문자와 소문자를 둘 다 사용하세요.',
    comboLettersAndNumbers: '숫자와 글자를 둘 다 사용하세요.',
    comboLettersNumbersSpecial: '숫자, 글자 및 특수 기호를 사용하세요.',
    yourPasswordIsStrong: '길이를 늘려서 더 강하게 만들 수 있습니다.',
    passwordStrength: '비밀번호 강도는 %%strength%%입니다.',
    strengthVeryStrong: '아주 강함',
    strengthStrong: '강함',
    strengthVeryWeak: '아주 약함',
    strengthWeak: '약함',
    strengthMedium: '보통',
    hidePassword: '비밀번호 숨기기',
    showPassword: '비밀번호 표시하기',
    generateButton: '생성하기',
    copyButtonHint: '비밀번호를 복사합니다',
    copySuccessToast: '비밀번호를 복사했습니다',
    generateButtonHint: '강력한 비밀번호를 생성합니다'
  },
  InPlaceEdit: {
    editButtonHint: '값 수정하기',
    okButtonHint: '변경 사항 저장하기',
    cancelButtonHint: '변경 사항 버리기'
  },
  InputFile: {
    browseButton: '파일 선택...'
  },
  List: {
    totalRows: '아이템 총 %%totalRows%%개',
    selectedRows: '아이템 %%selectedRows%%/%%totalRows%% 선택',
    all: '전체',
    allItemsOnPageSelected: '페이지의 아이템 전부 선택함',
    allItemsSelected: '아이템 전부 선택함',
    selectAllItems: '아이템 전부 선택하기',
    selectAllItemsOnPage: '페이지의 아이템 전부 선택하기',
    deselectAll: '선택 해제'
  },
  ListEmptyView: {
    filteredTitle: '필터와 일치하는 아이템을 찾을 수 없습니다',
    emptyTitle: '여기엔 아무것도 없는 것 같습니다',
    filteredDescription: '쿼리를 다듬거나 필터의 일부 기준을 제거하고 다시 시도하십시오.'
  },
  ListOperation: {
    cancelButton: '취소'
  },
  Pagination: {
    totalShort: '/%%total%%',
    itemsPerPage: '페이지당 아이템',
    all: '전체',
    total: '%%current%%/%%total%%페이지'
  },
  ProgressDialog: {
    closeButton: '닫기',
    cancelButton: '취소'
  },
  Select: {
    noOptions: '옵션 없음',
    placeholder: '선택하기...'
  },
  SpotPopup: {
    total: '%%current%%/%%total%%'
  },
  Toaster: {
    closeGroup: '그룹 닫기'
  }
};